import { render } from "./VideoInvestList.vue?vue&type=template&id=1ea76d74"
import script from "./VideoInvestList.vue?vue&type=script&lang=js"
export * from "./VideoInvestList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__